import React from 'react';
import styled from 'styled-components';
import { getCssSizeValue, getFontSize } from '@repo/utils';
import { BREAKPOINTS } from '@repo/ui/themeSettings';

const AuthorInfoWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	column-gap: ${getCssSizeValue(14, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({ theme }) => theme?.breakpoints?.tablet}px) {
		column-gap: ${getCssSizeValue(14, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({ theme }) => theme?.breakpoints?.desktop || 1024}px) {
		column-gap: ${getCssSizeValue(14, BREAKPOINTS.DESKTOP)};
	}
`;

const AuthorVideoWrapper = styled.div`
	width: 45px;
	height: 45px;
	border-radius: 50%;
	overflow: hidden;
	video {
		width: 100%;
	}
`;

const AuthorNameAndRole = styled.div`
	color: var(--secondary-color);
	p {
		font-size: ${getFontSize(14, BREAKPOINTS.MOBILE)}!important;
		line-height: normal !important;
		@media (min-width: ${({ theme }) => theme?.breakpoints?.tablet}px) {
			font-size: ${getFontSize(14, BREAKPOINTS.TABLET)}!important;
		}
		@media (min-width: ${({ theme }) => theme?.breakpoints?.desktop || 1024}px) {
			font-size: ${getFontSize(14, BREAKPOINTS.DESKTOP)}!important;
		}
	}
	p.name {
		font-weight: ${({ theme }) => theme.fontWeight.semiBold};
	}
	p.role {
		font-weight: ${({ theme }) => theme.fontWeight.regular};
	}
`;

const AuthorInfo = ({ name, jobTitle, videoUrl }) => {
	return (
		<AuthorInfoWrapper>
			<AuthorVideoWrapper>
				<video preload="auto" muted loop autoPlay={true} playsInline>
					<source src={videoUrl} type="video/mp4" />
				</video>
			</AuthorVideoWrapper>
			<AuthorNameAndRole>
				<p className="name">{name}</p>
				<p className="role">{jobTitle}</p>
			</AuthorNameAndRole>
		</AuthorInfoWrapper>
	);
};

export default AuthorInfo;
